function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.18 2h2.1a1 1 0 000-2h-2.1a1 1 0 000 2zM1 9.28a1 1 0 001-1v-2.1a1 1 0 00-2 0v2.1a1 1 0 001 1zM12.46 2a1 1 0 002 0V1a1 1 0 00-1-1h-1a1 1 0 100 2zM19 5.54h-4.54a1 1 0 00-2 0H6.54a1 1 0 00-1 1v5.92a1 1 0 000 2V19a1 1 0 001 1H19a1 1 0 001-1V6.54a1 1 0 00-1-1zM18 18H7.54V7.54H18V18zM2 0H1a1 1 0 00-1 1v1a1 1 0 002 0 1 1 0 000-2zm0 12.46a1 1 0 10-2 0v1a1 1 0 001 1h1a1 1 0 000-2z"
});
function SvgSquares(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref);
}
export default SvgSquares;